export default __webpack_public_path__ + "static/motivate-1d94dec7aebe1d3271965208236e1e19.svg";